import { render, staticRenderFns } from "./entity-features.vue?vue&type=template&id=8407feb2&"
import script from "./entity-features.vue?vue&type=script&lang=js&"
export * from "./entity-features.vue?vue&type=script&lang=js&"
import style0 from "./entity-features.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports